package com.essntl.features.category.ui.allcategories

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.category.domain.repository.CategoryRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllCategoriesViewModel(
    private val categoryRepository: CategoryRepository,
    private val state: MutableStateFlow<AllCategoriesState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AllCategoriesEvent) {
        when (event) {
            is AllCategoriesEvent.GetAllCategories -> getAllCategories()
            is AllCategoriesEvent.AddCategory -> addCategory(event)
            is AllCategoriesEvent.EditCategory -> editCategory(event)
            is AllCategoriesEvent.DeleteCategory -> deleteCategory(event)
        }
    }

    private fun getAllCategories() =
        getData(
            getData = { categoryRepository.getAll() },
            getState = { state.value.getAllCategories },
            setState = { newState -> state.update { it.copy(getAllCategories = newState) } },
        )

    private fun addCategory(event: AllCategoriesEvent.AddCategory) =
        state.update {
            it.copy(
                getAllCategories = it.getAllCategories.copy(
                    data = it.getAllCategories.data.orEmpty() + event.c,
                ),
            )
        }

    private fun editCategory(event: AllCategoriesEvent.EditCategory) =
        state.update {
            it.copy(
                getAllCategories = it.getAllCategories.copy(
                    data = it.getAllCategories.data
                        .orEmpty()
                        .map { c ->
                            if (c.id == event.c.id) event.c else c
                        },
                ),
            )
        }

    private fun deleteCategory(event: AllCategoriesEvent.DeleteCategory) =
        state.update {
            it.copy(
                getAllCategories = it.getAllCategories.copy(
                    data = it.getAllCategories.data
                        .orEmpty()
                        .filter { c ->
                            c.id != event.c.id
                        },
                ),
            )
        }
}